import { useMutation } from '@tanstack/react-query';

import Configurations from '../../../settings';
import { toastFn } from 'src/utils/helpers';
import { track } from '../../../utils/telemetry';

const submitInstantBidFile = async (data: any) => {
  try {
    const formData = new FormData();
    formData.append('file', data.file);
    const response = await fetch(
      `${Configurations.REACT_APP_API_ADDINSTANTBID}/jobs/upload?member_id=${data.memberId}`,
      {
        method: 'POST',
        body: formData,
      },
    );
    if (response.status !== 200) {
      throw new Error(response.statusText);
    }
    return await response.json();
  } catch (error) {
    toastFn(
      'error',
      'Failed to upload instant bid file. Please try again .',
    );
    track(
      'SubmitInstantBidFile -- useSubmitInstantBidFile.ts -- ERROR:',
      { error },
    );
    throw error;
  }
};

export const useSubmitInstantBidFile = (options = {}) => {
  return useMutation({
    mutationFn: async (data: any) => {
      if (!data?.file) {
        throw new Error('File is required');   }
      const response = await submitInstantBidFile(data);
      return response;
    },
    ...options,
  });
};
